module.exports = __webpack_public_path__ + "img/partners-timeline.54465717.png";